/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum EHopeApprenantSearchType {
    CURRENT = 'CURRENT',
    PAST = 'PAST',
    BOTH = 'BOTH'
}


export function EHopeApprenantSearchTypeFromJSON(json: any): EHopeApprenantSearchType {
    return EHopeApprenantSearchTypeFromJSONTyped(json, false);
}

export function EHopeApprenantSearchTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): EHopeApprenantSearchType {
    return json as EHopeApprenantSearchType;
}

export function EHopeApprenantSearchTypeToJSON(value?: EHopeApprenantSearchType | null): any {
    return value as any;
}

